/**
 * @file src/helpers/organization.ts
 * @exports ALL_ORGS_TEST_ID, getOrgSelectorTestId
 * @summary Shared identifiers for the organization picker, so the header trigger and the
 * dropdown rows are addressable by the same selectors.
 */

export const ALL_ORGS_TEST_ID = "org-selector-ALL-ORGS";

/**
 * Test id for one organization in the picker. Keyed on the display name rather than the id
 * because that is what end-to-end suites have always selected on. Rows also carry their id
 * in `data-org-id` for cases where two organizations share a name.
 */
export const getOrgSelectorTestId = ({ name }: { name?: string | null }) => `org-selector-${name || "unknown"}`;
